/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useContext } from 'react'
import TimePicker from './Time'

import ThemeControls from "../Component/AllThemesControl";

export default function TimeStartToEnd() {
  const {useStyle} = ThemeControls;
  const classes = useStyle();
  return (

    <div className={classes.timeInputGrp}>
     <TimePicker className={classes.timeInput} field_label='Starting Time'/>
     <h2>To</h2>
     <TimePicker className={classes.timeInput} field_label='End Time'/>
    </div>
  );
}
